module.exports = __webpack_public_path__ + "img/uz.1dc80048.svg";